module.exports = __webpack_public_path__ + "static/img/nav_bg.1ee28beb.png";